export default "dd78544d6f215fe7.svg"